import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const AudioOffIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.3 8.26C7.06 8.26 7.44 8.12 8.02 7.64L12.96 3.52V20.4L8.04 16.3C7.42 15.8 7.08 15.68 6.3 15.68H2.3V8.26H6.3ZM6.7 9.9H4.02V14H6.7C7.66 14 8.24 14.24 9.12 15L11.32 16.92V6.98L9.14 8.9C8.32 9.64 7.68 9.9 6.7 9.9Z" />
    </SvgIcon>
  );
});
